import React, { useState, useEffect, useRef } from 'react';
import "../../assets/css/login.css";
import { apiHandler } from '../../api';
import { endpoint } from '../../api/endpoint';
import { GENERATEOTP, VALIDATEOTP, CUSTOMERDATA, CUSTOMER_CART, GET_CUSTOMER_CART, BANNERS, GETWISHLIST_V2, WISHLIST_COUNT,C_COMPARE_LIST, CREATE_NEW_CUSTOMER, GETURLDATA } from '../../assets/graphql';
import { useNavigate } from "react-router-dom";
import { saveToken, saveUserData } from "../../features/login/loginDataSlice";
import { savecustomerresult, saveaddtoproductcart, saveBanner, savewishlist,saveCompareUidList, savelandingData, saveLogo } from '../../features/HomePageSlice/homeDataSlice';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getHomepageData } from '../../api/HomePage';
import { checkSessionValidity } from '../../utils/utils';
import RegisterModel from './RegisterModel';
const Login = () => {
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [isButtonDisabled, setButtonDisabled] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [userEmail, setUserEmail] = useState("");
    const [otpCode, setOtpCode] = useState("");
    const [textClass, settextClass] = useState("eamil-textfield")
    const [otpcodeError, setotpError] = useState(false);
    const [emailCheck, setemailCheck] = useState("");
    const [emailcodeError, setemailcodeError] = useState(false);
    const [otpexpiremsg, setotpexpiremsg] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [loader, setLoader] = useState(false);
    const [disableButton, setDisableButton] = useState(false);
    const searchInput = useRef(null);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const url = localStorage.getItem('loginURL');

    const getDataOfURL = async (value) => {
        const getURL = value;
        dispatch(dispatch(saveBanner("")));
        const result = await apiHandler({
          url: endpoint.GRAPHQL_URL,
          method: "POST",
          data: {
            base_url: endpoint.API_BASE_URL,
            variables: { getURL },
            query: GETURLDATA,
          },
        });
        if (!result.data.error_code) {
            dispatch(savelandingData(result.data.prelogin));
            dispatch(dispatch(saveBanner(result.data.prelogin.banners)));
            dispatch(saveLogo(result.data.prelogin.company[0].logo));
        }
    };
    
    const updateRecord = async (variables) => {
        variables = {
        ...variables,
        email: userEmail,
        };
        
        setButtonDisabled(true);
        setLoader(true);
        const result = await apiHandler({
        url: endpoint.GRAPHQL_URL,
        method: "POST",
        // authToken: token,
        data: {
            base_url: endpoint.API_BASE_URL,
            variables: variables,
            query: CREATE_NEW_CUSTOMER,
        },
        });
        if (result.data.registrationForm.status === "200") {
        // User Data is updated sucessfullly
        // toast.success(result.data.registrationForm.message);
            toast.success("The request has been submitted, and the team will contact you soon.");
            setShowAddressModal(false);
            setButtonDisabled(false);
            setUserEmail("")
            document.getElementById("cancelAddAddress").click();
        } else {
            // Error in updating User Data
            // toast.error(result.data.message);
            toast.error(result.data.registrationForm.message);
        }
    };

    const OTPValidation = () => {
        let isValid = true;
        var pattern = new RegExp(/^[0-9]+$/);
        if (otpCode.trim() === '') {
            setotpError('OTP is mandatory !')
            isValid = false;
        }
        else if (!pattern.test(otpCode)) {
            setotpError('OTP Should contain number only!')
            isValid = false;
        } else if (otpCode.length !== 6) {
            setotpError('OTP Should have length 6!')
            isValid = false;
        } else {
            setotpError('')
            return true;
        }
    }
   
    const EMAILValidation = () => {
        let isValid = true;
        var emailCheck = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (userEmail.trim() === '') {
            setemailcodeError('Email is mandatory !')
            settextClass("eamil-textfield-error")
            isValid = false;
        } else if(!emailCheck.test(userEmail)) {
            setemailcodeError('Email format is not valid')
            settextClass("eamil-textfield-error")
            return false;
        } else {
            setemailcodeError('')
            settextClass("eamil-textfield")
            return true;
        }
    }
    useEffect(() => {
        // current property is refered to input element
        searchInput.current.focus();
    }, [])

    const getCompareUidList = async (token) => {
        if (token) {
        const result = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            authToken: token,
            method: 'POST',
            data: {
                "base_url": endpoint.API_BASE_URL,
                "variables": {},
                "query": C_COMPARE_LIST
            },
        });
     
        if (result.data.customer) {
            dispatch(saveCompareUidList(result.data.customer.compare_list));
        }
    }
       
    };
    const LoginFn = async () => {
        if (EMAILValidation()) {
            setLoader(true);
            setDisableButton(true);
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": { email: userEmail, url: url},
                    "query": GENERATEOTP
                },
            });
            setDisableButton(false);
            setLoader(false);
            if (result.data && result.data.generateOtp && result.data.generateOtp.status && result.data.generateOtp.status == 1) {
                setShowLogin(true);
                toast.success(result.data.generateOtp.message,);
                setotpexpiremsg(result.data.generateOtp.otp_message);
                getHomepageData({dispatch});
            } else {
                // alert(result.data.generateOtp.message);
                // toast(result.data.generateOtp.message);
                if(result.data.generateOtp.status === 404) {
                    setShowAddressModal(true);
                    // setUserEmail("")
                }
                toast.error(result.data.generateOtp.message);
            }
        }
    };
    const RequestOtp = async () => {
        if (OTPValidation()) {
            setDisableButton(true);
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                data: {
                    "base_url": endpoint.API_BASE_URL,
                    "variables": { email: userEmail, otp: otpCode },
                    "query": VALIDATEOTP
                },
            });
        
            setDisableButton(false);
            setIsLoading(false);
            if (result.data && result.data.validateOtp && result.data.validateOtp.status && result.data.validateOtp.status == 1) {
           
                dispatch(saveToken(result.data.validateOtp.token));
                // getHomepageData();
                localStorage.setItem("sessionTimeOut", true);
                localStorage.setItem("loginCheck", true);
                localStorage.setItem("loginURL", result.data.validateOtp.url);
                getLoggedInUser(result.data.validateOtp.token);
                getCustomerCartDetails(result.data.validateOtp.token);
                getBannersList(result.data.validateOtp.token);
                getCompareUidList(result.data.validateOtp.token);
                if(result.data.validateOtp.url !== "default") {
                    getDataOfURL(result.data.validateOtp.url);
                }
                
                toast.error(result.data.generateOtp.message);
             
            } else {
                toast.error(result.data.validateOtp.message);
            
            }
        }
    };
    const getLoggedInUser = async (token) => {
        setLoader(true);
        const result = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            method: 'POST',
            authToken: token,
            data: {
                "base_url": endpoint.API_BASE_URL,
                "variables": {},
                "query": CUSTOMERDATA
            },
        });
        checkSessionValidity(result.data, dispatch);
        setLoader(false);
        navigate('/home');
        if (result.data && result.data.customer) {
            setShowLogin(false);
            dispatch(saveUserData(result.data.customer));
        } else {
            toast.error(result.data.customer.message)
        }
    };
    const getCustomerCartDetails = async (token) => {
        if (token) {
            const customerresult = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    base_url: endpoint.API_BASE_URL,
                    query: CUSTOMER_CART,
                    variables: {},
                },
            });
            if (!customerresult.data.error_code) {
                dispatch(savecustomerresult(customerresult.data.customerCart));
                getLatestCartInfo(token, customerresult.data.customerCart.id);
            }
        }
    };
    const getLatestCartInfo = async (token, cartId) => {
        if (token) {
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    base_url: endpoint.API_BASE_URL,
                    query: GET_CUSTOMER_CART,
                    variables: { cart_id: cartId },
                },
            });
            
            if (!result.data.message) {
                dispatch(
                    saveaddtoproductcart(result.data.cart)
                );
                getWishListData(token);
            }
            else if (result.data.message && result.data.message.data && result.data.message.data.cart) {
                dispatch(
                    saveaddtoproductcart(result.data.message.data.cart)
                );
                getWishListData(token);
            } else {
                const customerresult = await apiHandler({
                    url: endpoint.GRAPHQL_URL,
                    method: 'POST',
                    authToken: token,
                    data: {
                        base_url: endpoint.API_BASE_URL,
                        query: CUSTOMER_CART,
                        variables: {},
                    },
                });
                if (!customerresult.data.error_code) {
                    dispatch(savecustomerresult(customerresult.data.customerCart));
                    // getLatestCartInfo(token, customerresult.data.customerCart.id);
                }
            }
        }
    };
    const getWishListData = async (token) => {
        const wishlistCount = await apiHandler({
            url: endpoint.GRAPHQL_URL,
            method: 'POST',
            authToken: token,
            data: {
                base_url: endpoint.API_BASE_URL,
                variables: {},
                query: WISHLIST_COUNT,
            },
        });
        if (wishlistCount.data.wishlist) {
            if (wishlistCount.data.wishlist.items_count > 0) {
                const wishlistresult = await apiHandler({
                    url: endpoint.GRAPHQL_URL,
                    method: 'POST',
                    authToken: token,
                    data: {
                        base_url: endpoint.API_BASE_URL,
                        variables: {},
                        query: GETWISHLIST_V2,
                    },
                });
                if (!wishlistresult.data.error_code) {
                    dispatch(savewishlist(wishlistresult.data.customer.wishlist_v2));
                }
            }
        }
    };
    const getBannersList = async (token) => {
        if (token) {
            const result = await apiHandler({
                url: endpoint.GRAPHQL_URL,
                method: 'POST',
                authToken: token,
                data: {
                    base_url: endpoint.API_BASE_URL,
                    query: BANNERS,
                    variables: {},
                },
            });
            
            if (!result.data.message) {
                dispatch(
                    dispatch(saveBanner(result.data.sliderdata))
                );
            }
            else {
                toast.error(result.data.message);
               
            }
        }
    };
    const handleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            LoginFn();
        }
    };
    const resendhandleKeypress = e => {
        //it triggers by pressing the enter key
        if (e.keyCode === 13) {
            RequestOtp();
        }
    };
    return (
        <>
            {/* <section className="custombreadcrumb">
                <div className="container">
                    <ul className="breadcrumb justify-content-start">
                        <li className="breadcrumb-item"><a href="/#/home">Home</a></li>
                        <li className="breadcrumb-item active">My Cart</li>
                    </ul>
                </div>
            </section> */}
            <section className="login_wrap">
                <div className="container">
                    <div className="loginform_wrap">
                        {/* <div className="row">
                            <div className="col-xl-9 mx-auto text-center pt-2 pb-4">
                                <div className="mainsection-title">
                                    <h2>Login</h2>
                                </div>
                            </div>
                        </div> */}
                        <div className="col-xl-9 mx-auto ">
                            <div className="row">
                                <div className="col-lg-6" style={{ padding: "5px" }}>
                                    <div className="login_options">
                                        <h3>Login or Create an account</h3>
                                        <p>
                                            By creating an account with our store, you will be able to:
                                        </p>
                                        <ul>
                                            <li>- Move through the checkout process faster.</li>
                                            <li>- Store multiple shipping addresses.</li>
                                            <li>- View and track your orders in your account and more.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-lg-6" style={{ padding: "10px" }}>
                                    <div className="log_sign_form">
                                        <p>If you have an account with us, please log in.</p>
                                        <div >
                                            {showLogin ? (<>
                                                <div className="otp_box" >
                                                    <div className="form_row">
                                                        <label htmlFor="">Enter OTP:</label>
                                                        <input type="text" name="otp" id="otp" value={otpCode} onChange={(e) => setOtpCode(e.target.value)} onKeyDown={(e) => resendhandleKeypress(e)} placeholder="" onBlur={OTPValidation} />
                                                    </div>
                                                    <span className='color_red'>{otpcodeError}</span><br />
                                                    <span className='color_green'>{otpexpiremsg}</span>
                                                    <div className="form_row">
                                                        <button className="btn default_button" disabled={disableButton} onClick={() => RequestOtp()}>Login</button>&nbsp;&nbsp;
                                                        <button className='btn default_button'  disabled={disableButton} onClick={() => LoginFn()}>Resend OTP</button>
                                                    </div>
                                                </div>
                                            </>) : (<>
                                                <div className="mobile_box">
                                                    <div className="form_row">
                                                        <label htmlFor="email" >Enter Your Email:</label>
                                                        <input type="text" name="email" id="email" ref={searchInput} value={userEmail} onChange={(e) => setUserEmail(e.target.value)} onKeyDown={(e) => handleKeypress(e)} placeholder="Enter email id" class={textClass} />
                                                        <span className='color_red'>{emailcodeError}</span><br />
                                                    </div>
                                                    <div className="form_row">
                                                        <button type="submit" className="btn default_button" disabled={disableButton} onClick={LoginFn} >Request OTP</button>
                                                    </div>
                                                </div>
                                            </>)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <button onClick={openModal}>Open Modal</button> */}
                <RegisterModel
                showModal={showAddressModal}
                emailAddress={userEmail}
                updateRecord={updateRecord}
                closeModal={() => setShowAddressModal(false)}
                buttonCheck={isButtonDisabled} />
                      
            </section>
           
            {/* {loader && (
                <div className='loading-overlay'>
                    <div className='bounce-loader'> */}
            {/* <div className='bounce1'></div>
                                <div className='bounce2'></div>
                                <div className='bounce3'></div> */}
            {/* <div className="loader"></div>
                    </div>
                </div>
            )} */}
        </>
    )
}
export default Login